export enum FishBehaviorType {
    Drift = "Drift",
    Patrol = "Patrol",
    Cruise = "Cruise",
    FigureEight = "FigureEight",
    DartPause = "DartPause",
    Flee = "Flee",
}

export enum SpawnFrequency {
    VeryCommon = "VeryCommon",
    Common = "Common",
    Uncommon = "Uncommon",
    Rare = "Rare",
}

export enum WeaponType {
    Spear = "Spear",
    Trident = "Trident",
    Bow = "Bow",
}

export enum PowerUpType {
    Trident = "Trident",
    Bow = "Bow",
    GasCan = "GasCan",
    SpeedBoost = "SpeedBoost",
    FishFrenzy = "FishFrenzy",
}

export enum SeasonType {
    Spring = "Spring",
    Summer = "Summer",
    Fall = "Fall",
    Winter = "Winter",
}

export enum SeasonSelection {
    Random = "Random",
    Spring = "Spring",
    Summer = "Summer",
    Fall = "Fall",
    Winter = "Winter",
}
